import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DurationPicker from 'components/durationPicker/duration-picker';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import { Checkbox, Form, Input } from 'antd';
import _ from 'lodash';
import { FormWrapper } from 'components/Page';
import settings from 'config/settings';
import { convertToSelect, getKey, getLabel } from 'library/helpers';
import REDUCER_KEY from 'reducers/reducer.keys';
import { list } from 'actions';

const FormItem = Form.Item;
const { TextArea } = Input;

const mapStateToProps = state => ({
  inFlight: state.api.competencyTypes.inFlight,
  competencyTypes: state.api.competencyTypes.data.results
});

const mapDispatchToProps = dispatch => ({
  loadTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'is_integration_managed',
      value: false
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    return dispatch(list(REDUCER_KEY.competencyTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    name, lms_code, competency_type, description, validity_period, active
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    lms_code: Form.createFormField({ value: lms_code }),
    competency_type: Form.createFormField({ value: convertToSelect(competency_type) }),
    validity_period: Form.createFormField({ value: validity_period }),
    active: Form.createFormField({ value: active }),
    description: Form.createFormField({ value: description })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: fieldsChange } = props;
  if (fieldsChange) {
    fieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: valuesChange } = props;
  if (valuesChange) {
    valuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, competencyTypes, dataSource, inFlight, inputFormItemLayout, form, loadTypes
}) => {
  const { getFieldDecorator } = form;
  const {
    name, lms_code, competency_type, description, validity_period, active, is_integration_managed
  } = dataSource;
  const readonly = !canAdmin || is_integration_managed;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Competency name.'
            }]
          })(<TextArea
            disabled={readonly}
            autosize={{
              minRows: 1,
              maxRows: 3
            }}
          />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Success Factors Code">
        {getFieldDecorator('lms_code', {
          initialValue: lms_code
        })(<Input disabled />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Competency Type">
        {getFieldDecorator('competency_type', {
          initialValue: competency_type,
          rules: [
            {
              required: true,
              message: 'Please select a Competency Type.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={inFlight}
            placeholder="Select Competency Type"
            disabled={readonly}
            dataSource={competencyTypes}
            optionKey={getKey}
            optionLabel={getLabel}
            onSearch={loadTypes}
            onFocus={loadTypes}
            onBlur={loadTypes}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Validity Period">
        {getFieldDecorator('validity_period', {
          initialValue: validity_period
        })(<DurationPicker disabled={readonly} showHours={false} showMinutes={false} />)}
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('is_integration_managed', {
            initialValue: is_integration_managed,
            valuePropName: 'checked'
          })(
            <Checkbox disabled>
              Managed in Success Factors
            </Checkbox>
          )
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Description">
        {getFieldDecorator('description', {
          initialValue: description
        })(<TextArea
          disabled={readonly}
          placeholder="Description of the skills involved"
          autosize={{
            minRows: 2,
            maxRows: 10
          }}
        />)}
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  competencyTypes: PropTypes.array,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inFlight: PropTypes.bool,
  inputFormItemLayout: PropTypes.object,
  loadTypes: PropTypes.func,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  competencyTypes: [],
  dataSource: {},
  form: {},
  inFlight: false,
  inputFormItemLayout: {},
  loadTypes() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ConnectedFormInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormInput);

const CompetencyFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default CompetencyFormInput;
